import apiService from './api';

const BIBLE_URL = '/bible';

// Get all Bible books
export const getAllBooks = async () => {
  try {
    const response = await apiService.get(`${BIBLE_URL}/books`);
    return response;
  } catch (error) {
    console.error('Failed to get Bible books:', error);
    throw error;
  }
};

// Get a specific Bible book
export const getBook = async (bookName) => {
  try {
    console.log(`bibleService: Fetching book ${bookName}`);
    const endpoint = `${BIBLE_URL}/book/${bookName}`;
    console.log(`bibleService: Using endpoint: ${endpoint}`);
    const response = await apiService.get(endpoint);
    console.log('bibleService: Book response:', response);
    return response;
  } catch (error) {
    console.error('Failed to get Bible book:', error);
    console.error('Error details:', {
      message: error.message,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      } : 'No response data',
      request: error.request ? 'Request object exists' : 'No request object'
    });
    throw error;
  }
};

// Get Bible passage content
export const getPassage = async (book, chapter) => {
  try {
    console.log(`bibleService: Fetching passage for ${book} ${chapter}`);
    const endpoint = `${BIBLE_URL}/passage/${book}/${chapter}`;
    console.log(`bibleService: Using endpoint: ${endpoint}`);
    const response = await apiService.get(endpoint);
    console.log('bibleService: Passage response:', response);
    return response;
  } catch (error) {
    console.error('Failed to get Bible passage:', error);
    console.error('Error details:', {
      message: error.message,
      response: error.response ? {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      } : 'No response data',
      request: error.request ? 'Request object exists' : 'No request object'
    });
    throw error;
  }
};

// Get unique chapter number for a book and chapter
export const getUniqueChapterNumber = async (book, chapter) => {
  try {
    // Using the exact endpoint format specified: /api/bible/chapter?book=Genesis&chapter=1
    const response = await apiService.get(`${BIBLE_URL}/chapter`, {
      params: { 
        book: book,
        chapter: chapter 
      }
    });
    console.log('Unique chapter number response:', response);
    return response;
  } catch (error) {
    console.error('Failed to get unique chapter number:', error);
    throw error;
  }
};

// Get chapter details by unique chapter number
export const getChapterByUniqueNumber = async (uniqueChapterNumber) => {
  try {
    const response = await apiService.get(`${BIBLE_URL}/unique-chapter/${uniqueChapterNumber}`);
    return response;
  } catch (error) {
    console.error('Failed to get chapter by unique number:', error);
    throw error;
  }
}; 